import PropTypes from 'prop-types';
import {
  BooleanInput,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  email,
  Identifier,
  ReferenceField,
  ReferenceInput,
  ReferenceManyField,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  usePermissions,
  useTranslate,
} from 'react-admin';

const UserEditToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
const UserEditEmbedded = ({ id }: { id?: Identifier }) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  return (
    <Edit title=" " id={id}>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <TextInput source="first_name" validate={required()} disabled={permissions != 'master'} />
        <TextInput source="last_name" validate={required()} disabled={permissions != 'master'} />
        <TextInput source="email" validate={[required(), email()]} disabled={permissions != 'master'} />
        {permissions === 'ediop' && <TextInput source="password" />}
        {permissions === 'master' && (
          <ReferenceInput source="role" reference="role">
            <SelectInput optionText="name" validate={[required()]} />
          </ReferenceInput>
        )}
        {permissions === 'master' && <BooleanInput label="Disabled" source="deleted" />}
        <ReferenceManyField
          source="id"
          reference="subscriptions"
          label="Subscriptions"
          sort={{ field: 'created_at', order: 'ASC' }}
          target={'user_id'}
        >
          <Datagrid bulkActionButtons={false}>
            <ReferenceField source="plan_id" reference="plans" label={translate('resources.user.fields.plan')}>
              <TextField source="tier_id" />
            </ReferenceField>
            <DateField
              source="current_period_start"
              showTime
              locales="ja-JP"
              label={translate('resources.user.fields.current_period_start')}
            />
            <DateField
              source="current_period_end"
              showTime
              locales="ja-JP"
              label={translate('resources.user.fields.current_period_end')}
            />
            <EditButton />
          </Datagrid>
        </ReferenceManyField>
      </SimpleForm>
    </Edit>
  );
};

UserEditEmbedded.propTypes = {
  record: PropTypes.object,
  resource: PropTypes.string,
  id: PropTypes.string,
};

export default UserEditEmbedded;
